import type { PropsWithChildren } from 'react';
import { Navigate } from 'react-router-dom';
import { PageLoader } from '../../shared/ui/PageLoader.js';
import { useAuth } from './AuthProvider.js';
import { authGate, GATE_PATH } from './authGate.js';

/** Route guard: signed in WITH a confirmed email, or off to the screen that
 *  fixes it — sign-in, or "check your inbox" (doc 88 D10). */
export function RequireAuth({ children }: PropsWithChildren) {
  const gate = authGate(useAuth());
  if (gate === 'loading') return <PageLoader />;
  if (gate !== 'ready') return <Navigate to={GATE_PATH[gate]} replace />;
  return <>{children}</>;
}
